<form [formGroup]="form" class="flex-col gap-4">
  <div class="flex-col lg-flex-row gap-4">
    <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
      <mat-label>{{ 'generic.subtitle' | translate }}</mat-label>
      <input type="text" formControlName="subtitle" matInput>
    </mat-form-field>
  </div>
  <div class="section-outline on-focus">
    <quill-editor
      bounds="self"
      theme="bubble"
      formControlName="content"
      appOnFocus
      [placeholder]="'generic.content.placeholder' | translate"
    ></quill-editor>
  </div>
</form>
